// **React Imports
import { memo, useMemo } from 'react'

// **Components Imports
import { Box, Tooltip, Typography } from '@mui/material'
import Icon from '../icon'

// **Hooks Imports
import useDemoUser from '../../hooks/useDemoUser'

// **Style Imports
import { ENVIRONMENT } from '../../env/env'
import './styles.css'

const DemoBannerStrip = () => {
  // ** hooks
  const { isDemoUser, isDemoTenant } = useDemoUser()

  // ** variables
  const content = useMemo(() => {
    return isDemoTenant
      ? 'You are viewing a read-only demo. Mutating actions are disabled.'
      : 'You have readonly access. Mutating actions are disabled.'
  }, [isDemoTenant])

  const signupUrl = useMemo(() => {
    return ENVIRONMENT === 'DEV'
      ? 'https://dev.coderscout.io/signup'
      : 'https://app.coderscout.io/signup'
  }, [])

  if (!isDemoUser) return null

  return (
    <Box
      className="demo-banner-strip-container"
      role="status"
      aria-label="Demo mode warning"
    >
      <Box className="demo-banner-strip-content">
        <Box className="demo-banner-strip-left">
          <Icon icon="mdi:alert-outline" className="demo-strip-icon" />
          <Typography className="demo-banner-strip-text">
            <strong>DEMO MODE: &nbsp;</strong> {content}
          </Typography>
        </Box>
        {isDemoTenant && (
          <Box className="demo-banner-strip-right">
            <Tooltip title="Go back to website" arrow>
              <a
                href="https://www.coderscout.io/"
                rel="noreferrer"
                size="small"
                className="demo-strip-action-btn"
              >
                <Icon icon="ic:round-arrow-back" />
              </a>
            </Tooltip>
            <Tooltip title="Try free trial" arrow>
              <a
                href={signupUrl}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                className="demo-strip-action-btn demo-strip-action-btn-contained"
              >
                <Icon icon="mdi:lightning-bolt" />
              </a>
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default memo(DemoBannerStrip)
